import NotificationsRepository, {
  NotificationsListResult,
} from "@/core/notifications/repositories/NotificationsRepository";
import type { Notification } from "@/core/notifications/entities/Notification";
import {
  RepositoryResult,
  RepositoryResultFactory,
} from "@/core/shared/types/RepositoryResult";
import { subDays, subHours, subMinutes } from "date-fns";

const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: "n1",
    category: "compliance",
    title: "Validation L1 en attente",
    message: "Le dossier KYC de M. Koné nécessite une revue conformité.",
    createdAt: subMinutes(new Date(), 25),
    read: false,
  },
  {
    id: "n2",
    category: "administration",
    title: "Nouveau rôle créé",
    message: "Le rôle « Gestionnaire agence » a été ajouté à la matrice RBAC.",
    createdAt: subHours(new Date(), 3),
    read: false,
  },
  {
    id: "n3",
    category: "client",
    title: "Client sensible détecté",
    message: "Une recherche Client 360 a retourné un profil marqué sensible.",
    createdAt: subHours(new Date(), 8),
    read: true,
  },
  {
    id: "n4",
    category: "system",
    title: "Import référentiel terminé",
    message: "12 entités risque mises à jour, 0 erreur.",
    createdAt: subDays(new Date(), 1),
    read: true,
  },
  {
    id: "n5",
    category: "compliance",
    title: "P4 — validation requise",
    message: "2 dossiers en attente de validation finale.",
    createdAt: subDays(new Date(), 3),
    read: true,
  },
];

/**
 * Mock implementation of NotificationsRepository for development.
 *
 * To switch to the real API when ready, in ServiceContainer.ts replace:
 *   new FakeNotificationsRepositoryBackend()
 * with:
 *   new NotificationsRepositoryBackend(httpClient)
 */
export default class FakeNotificationsRepositoryBackend
  implements NotificationsRepository
{
  async getNotifications(): Promise<RepositoryResult<NotificationsListResult>> {
    await new Promise((resolve) => setTimeout(resolve, 600));

    const unreadCount = MOCK_NOTIFICATIONS.filter((n) => !n.read).length;

    return RepositoryResultFactory.success({
      items: MOCK_NOTIFICATIONS.map((n) => ({ ...n })),
      unreadCount,
    });
  }
}
